<section class="mu-home">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 offset-lg-0 col-md-11 offset-md-1 col-12">
                <div class="col-12">
                    <div class="row">
                        <div class="col-md-12 mb-2 empl-tptxt">
                            <h3> New Query </h3>
                        </div>
                        <div class="col-12 col-md-6">
                            <form [formGroup]="createQueryForm">
                                <div class="row">
                                    <div class="col-12 col-md-12">
                                        <app-category-selector [module]="module"
                                            (categorySelectorEvent)="onCategorySelected($event)"></app-category-selector>
                                    </div>
                                    <div class="col-12">
                                        <div class="mb-3">
                                            <label for="queryName" class="form-label">Query Heading<sup>*</sup></label>
                                            <input type="text" placeholder="Search or Type Query" [formControlName]="titleControlName" [matAutocomplete]="auto"
                                                class="form-control"
                                                [ngClass]="{ 'is-invalid':  f['title'].errors && (f['title'].touched) }">
                                            <mat-autocomplete #auto="matAutocomplete">
                                                <mat-option *ngFor="let queryTaskType of filteredTaskTypes | async"
                                                    [value]="queryTaskType.label">
                                                    {{queryTaskType.label}}
                                                </mat-option>
                                            </mat-autocomplete>
                                            <app-validation field="title" [form]="createQueryForm"
                                                [error]="{required:'This is a mandatory field, Kindly select Query Name'}"></app-validation>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="mb-3">
                                            <label for="exampleFormControlTextarea1"
                                                class="form-label">Description <sup>*</sup></label>
                                            <textarea class="form-control" id="exampleFormControlTextarea1" rows="4"
                                                formControlName="description"
                                                [ngClass]="{ 'is-invalid':  f['description'].errors && (f['description'].touched) }"></textarea>
                                            <app-validation field="description" [form]="createQueryForm"
                                                [error]="{required:'This is a mandatory field, Kindly add description', minLength:'Description should have minimum 5 characters.', maxLength:'Max 5000 characters allowed'}"></app-validation>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="col-12 col-md-6">
                            <p>Upload Documents</p>
                            <app-multiple-file-selector (chooseFiles)="handleFileInput($event)"
                                (removeFiles)="clearSelectedFiles($event)"></app-multiple-file-selector>
                            <div id="images-show"></div>
                        </div>
                        <div class="col-12 d-flex justify-content-end acvtypglastbtn">
                            <button type="button" class="btn-actvtytp" (click)="saveAndExit()">SAVE</button>
                            <button type="button" class="btn-discard" (click)="exit()">CANCEL</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
